import { useCallback, useState } from 'react';

const EMPTY_LIGHTBOX = { isOpen: false, mode: 'image', images: [], index: 0, text: '' };

export function useLightbox() {
    const [lightbox, setLightbox] = useState(EMPTY_LIGHTBOX);

    const openLightbox = useCallback((images, index = 0) => {
        if (!images || !images.length) return;
        setLightbox({ isOpen: true, mode: 'image', images, index, text: '' });
    }, []);

    const openTextLightbox = useCallback((text) => {
        if (!text) return;
        setLightbox({ isOpen: true, mode: 'text', images: [], index: 0, text });
    }, []);

    const closeLightbox = useCallback(() => {
        setLightbox(EMPTY_LIGHTBOX);
    }, []);

    const goLightbox = useCallback((direction) => {
        setLightbox((prev) => {
            if (!prev.images.length) return prev;
            const nextIndex = (prev.index + direction + prev.images.length) % prev.images.length;
            return { ...prev, index: nextIndex };
        });
    }, []);

    return {
        lightbox,
        openLightbox,
        openTextLightbox,
        closeLightbox,
        goLightbox
    };
}
